import { render, staticRenderFns } from "./channelPay.vue?vue&type=template&id=60da2d60&scoped=true&"
import script from "./channelPay.vue?vue&type=script&lang=js&"
export * from "./channelPay.vue?vue&type=script&lang=js&"
import style0 from "./channelPay.vue?vue&type=style&index=0&id=60da2d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da2d60",
  null
  
)

export default component.exports